const cardViewStyles = {

    containerStyle: {
        maxWidth: '1150px',
        margin: '0 auto',
        padding: '24px',
        minHeight: '100vh'
    },

    cardStyle: {
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)',
        padding: '24px',
        marginBottom: '24px',
        border: '1px solid #e5e7eb',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
    },

    headerSectionStyle: {
        marginBottom: '20px',
        paddingBottom: '16px',
        borderBottom: '2px solid #f3f4f6'
    },

    headerTitleStyle: {
        fontSize: '20px',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },

    headerGridStyle: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '16px',
        marginTop: '12px'
    },

    headerItemStyle: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px'
    },

    labelStyle: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#6b7280',
        // textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },

    valueStyle: {
        fontSize: '15px',
        fontWeight: '600',
        color: '#111827'
    },

    tableContainerStyle: {
        overflowX: 'auto',
        marginTop: '16px'
    },

    tableStyle: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '14px'
    },

    tableHeaderStyle: {
        backgroundColor: '#03a9f4',
        borderBottom: '2px solid #e5e7eb'
    },

    thStyle: {
        padding: '12px 16px',
        textAlign: 'left',
        fontWeight: '700',
        color: '#ffffffff',
        fontSize: '14px',
        // textTransform: 'uppercase',
        letterSpacing: '0.5px'
    },

    tdStyle: {
        padding: '12px 16px',
        borderBottom: '1px solid #f3f4f6',
        color: '#4b5563'
    },


    titleStyle: {
        fontSize: '28px',
        fontWeight: '700',
        color: '#111827',
        marginBottom: '24px',
        textAlign: 'center'
    },

    badgeStyle: {
        display: 'inline-block',
        padding: '4px 12px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: '600',
        backgroundColor: '#dbeafe',
        color: '#1e40af',
        width: '160px'
    },

    noDataTextStyle: {
        fontSize: '18px',
        fontWeight: '600',
        color: '#6b7280',
        marginBottom: '8px'
    },

    noDataStyle: {
        textAlign: 'center',
        padding: '60px 24px',
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        margin: '40px 0'
    },

    noDataSubtextStyle: {
        fontSize: '14px',
        color: '#9ca3af'
    },
}

export default cardViewStyles;
